@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.TruncatedItemList {
  position: relative;
  display: inline-block;
  height: 3em;

  > button {
    @extend %font-family-primary;

    color: $color-grey-B;
    background: none;
  }

  > [role='listbox'] {
    max-height: 3em;
    overflow: hidden;
    display: grid;
  }

  &[aria-expanded='false'] {
    > button {
      width: 100%;
      height: 100%;
      position: absolute;
      border: 0;
      cursor: zoom-in;
      margin: 0;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      display: flex;
      padding: 0;
      padding-bottom: 0.25em;
    }

    [role='option'] {
      display: inline-block;
      padding-right: 1em;
    }
  }

  &[aria-expanded='true'] {
    > button {
      display: block;
      background: $theme-color-background;
    }

    > [role='listbox'] {
      background: $theme-color-background;
      border: 1px solid $color-grey-E;
      position: absolute;
      width: unset;
      max-height: none;
      z-index: 1;
      padding: 1em;
      border-radius: 4px;
    }
  }
}

.TruncatedPopOutItemListButton {
    @extend %font-family-primary;

    color: $color-grey-B;
    background: none;

    &[aria-expanded='false'] {
      width: 100%;
      height: 100%;
      position: absolute;
      border: 0;
      cursor: zoom-in;
      margin: 0;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      display: flex;
      padding: 0;
      padding-bottom: 0.25em;
  }

    &[aria-expanded='true'] {
      display: block;
      background: $theme-color-background;
  }
}

.TruncatedPopOutItemListOptions {
      background: $theme-color-background;
      border: 1px solid $color-grey-E;
      position: absolute;
      width: unset;
      max-height: none;
      z-index: 1;
      padding: 1em;
      border-radius: 4px;
    }